import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=af1c78bc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af1c78bc')) {
      api.createRecord('af1c78bc', component.options)
    } else {
      api.reload('af1c78bc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=af1c78bc&", function () {
      api.rerender('af1c78bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tv6drpUt1QR7/JS/comp/FavElement.vue"
export default component.exports